// extracted by mini-css-extract-plugin
module.exports = {"skipNav":"jut__SkipNav__skipNav"};